<template>
  <div class="fill-height">
    <v-container grid-list-xs class="d-flex justify-center">
      <div class="card-container">
        <v-container
          grid-list-xs
          class="d-flex flex-column justify-center align-center py-16"
        >
          <v-card class="card-radius card-shadow card-width" elevation="0">
            <v-card-title
              primary-title
              class="accentDarkBlue white--text title font-weight-medium px-10"
              >Lupa Password</v-card-title
            >

            <v-container grid-list-xs class="py-5">
              <v-form class="form px-5" ref="form" v-on:submit.prevent>
                <div>
                  Masukkan alamat email yang kamu gunakan untuk membuat akun
                  PPDB, kami akan mengirimkan email untuk mereset password Anda!
                </div>
                <v-text-field
                  label="Email"
                  class="mt-6"
                  v-model="email"
                  filled
                  :rules="emailRules"
                  @keyup.enter.native="login"
                >
                  <template v-slot:prepend-inner>
                    <v-icon class="mx-2">mdi-email-outline</v-icon>
                  </template>
                </v-text-field>
                <center class="mt-2">
                  <p v-if="error" class="red--text caption">{{ error }}</p>

                  <v-btn
                    style="width: 100%; font-size: 1rem"
                    color="accentDarkBlue white--text py-6 mb-3"
                    @click="send"
                    >Kirim</v-btn
                  >
                </center>
              </v-form>
            </v-container>
          </v-card>
        </v-container>
      </div>
      <v-snackbar :color="color" v-model="snackbar" :timeout="timeout">
        {{ text }}

        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { EventBus } from "../event-bus";

export default {
  data: () => ({
    email: "",
    error: "",
    emailRules: [
      (v) => !!v || "Mohon isi email",
      (v) => /.+@.+\..+/.test(v) || "Email tidak valid",
    ],
    text: "",
    timeout: 5000,
    color: "green",
    snackbar: false,
  }),
  mounted() {},
  methods: {
    async send() {
      if (this.$refs.form.validate()) {
        EventBus.$emit("startLoading");

        const resEmail = await axios.post(`${this.$api}/password/email`, {
          email: this.email,
        });

        if (resEmail.data.STATUS == "ERROR") {
          EventBus.$emit("stopLoading");
          this.error = resEmail.data.MESSAGE;
          this.text = resEmail.data.MESSAGE;
          this.color = "red";
          this.snackbar = true;

          return;
        } else {
          EventBus.$emit("stopLoading");
          this.error = "";
          this.color = "green";
          this.text = resEmail.data.MESSAGE;
          this.snackbar = true;
        }

        EventBus.$emit("stopLoading");
      }
    },
  },
};
</script>

<style scoped>
.card-width {
  width: 30rem;
}

.card-container {
  width: 100%;
}

.card-shadow {
  box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.08), 2px 2px 4px rgba(0, 0, 0, 0.08) !important;
}

.pink-color {
  background-color: #fec0a0;
}

.card-text {
  font-size: 1.2rem;
}

.card-radius {
  border-radius: 10px !important;
}

.icon-radius {
  border-radius: 7px !important;
}

.card-wrapper {
  margin: 100px 0;
  width: 70%;
}

.inbox-card {
  border-left: 8px solid #2a429e;
}

.a-link {
  text-decoration: none;
  color: #2a429e;
}

.a-link:hover {
  text-decoration: underline;
}

@media screen and (max-width: 600px) {
  .card-width {
    width: 100%;
  }

  .card-text {
    font-size: 1rem;
  }
}
</style>
